import { HEX } from "../../../src/actions/hex-patterns";
import { Targeting } from "../../../src/actions/targeting";
import { SEC } from "../../../src/time-utils";
import {
  SCALING,
  SPICE_MAGIC
} from "../../../src/actions/scaling-presets";
const arrow_shot = {
  slug: "arrow_shot",
  name: "Arrow Shot",
  abilityIcon: "arrow_shot",
  description: "Fire an arrow at a distant target",
  costs: [],
  targeting: Targeting.MissileMid,
  cooldown: SEC(2),
  projectileSpeed: 8,
  // 8 ticks per hex
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: SCALING.PIERCING
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "ranged", "bow"]
};
const fire_arrow = {
  slug: "fire_arrow",
  name: "Fire Arrow",
  abilityIcon: "fire_arrow",
  description: "An arrow tipped with alchemical fire",
  costs: [{ stat: "energy", value: 6 }],
  targeting: Targeting.MissileMid,
  cooldown: SEC(3),
  projectileSpeed: 8,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.PIERCING,
                red: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "ranged", "bow", "red"]
};
const arcane_arrow = {
  slug: "arcane_arrow",
  name: "Arcane Arrow",
  abilityIcon: "arcane_arrow",
  description: "An arrow crackling with unstable arcane energy",
  costs: [{ stat: "energy", value: 6 }],
  targeting: Targeting.MissileMid,
  cooldown: SEC(3),
  projectileSpeed: 8,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.PIERCING,
                blue: { ...SPICE_MAGIC, rating: 2 }
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "ranged", "bow", "blue"]
};
const shadow_arrow = {
  slug: "shadow_arrow",
  name: "Shadow Arrow",
  abilityIcon: "shadow_arrow",
  description: "An arrow cloaked in shadow, harder to resist",
  costs: [{ stat: "energy", value: 6 }],
  targeting: Targeting.MissileMid,
  cooldown: SEC(3),
  projectileSpeed: 8,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.PIERCING,
                black: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "ranged", "bow", "black"]
};
const radiant_arrow = {
  slug: "radiant_arrow",
  name: "Radiant Arrow",
  abilityIcon: "radiant_arrow",
  description: "An arrow wreathed in holy light, guided by divine will",
  costs: [{ stat: "energy", value: 6 }],
  targeting: Targeting.MissileMid,
  cooldown: SEC(3),
  projectileSpeed: 8,
  impactSchedule: {
    [0]: [
      {
        hexes: HEX.DOT,
        effect: {
          statChanges: [
            {
              stat: "health",
              direction: "loss",
              scalingFactors: {
                ...SCALING.PIERCING,
                gold: SPICE_MAGIC
              }
            }
          ],
          addConditions: [],
          removeConditionsByTag: []
        }
      }
    ]
  },
  tags: ["attack", "ranged", "bow", "gold"]
};
export {
  arcane_arrow,
  arrow_shot,
  fire_arrow,
  radiant_arrow,
  shadow_arrow
};
//# sourceMappingURL=data:application/json;base64,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
